import { useNode } from '@craftjs/core';
import { cn } from '../../../../lib/utils';

interface QuoteBlockProps {
  text: string;
  citation: string;
  borderColor: string;
}

export function QuoteBlock({ text, citation, borderColor }: QuoteBlockProps) {
  const {
    connectors: { connect, drag },
    selected,
    actions: { setProp },
  } = useNode((state) => ({
    selected: state.events.selected,
  }));

  return (
    <div
      ref={(ref) => {
        if (ref) connect(drag(ref));
      }}
      className={cn(
        'p-2 rounded transition-all',
        selected && 'ring-2 ring-primary ring-offset-2'
      )}
    >
      <blockquote
        className="pl-4 py-2 italic text-muted-foreground"
        style={{ borderLeft: `4px solid ${borderColor}` }}
      >
        <p
          contentEditable={selected}
          suppressContentEditableWarning
          className="outline-none text-base leading-relaxed"
          onBlur={(e) => {
            setProp((props: QuoteBlockProps) => {
              props.text = e.currentTarget.textContent || '';
            });
          }}
        >
          {text}
        </p>
        {(citation || selected) && (
          <footer className="mt-2 text-sm not-italic">
            <cite
              contentEditable={selected}
              suppressContentEditableWarning
              className="outline-none"
              onBlur={(e) => {
                setProp((props: QuoteBlockProps) => {
                  props.citation = e.currentTarget.textContent || '';
                });
              }}
            >
              {citation || (selected ? 'Fonte (opcional)' : '')}
            </cite>
          </footer>
        )}
      </blockquote>
    </div>
  );
}

QuoteBlock.craft = {
  displayName: 'Citação',
  props: {
    text: 'Citação aqui',
    citation: '',
    borderColor: '#50E3C2',
  },
  rules: { canDrag: () => true },
};
